export default ({ ids, where }) => ({
  where: where ?? {
    id: {
      _in: ids
    }
  }
})
